<ion-header class="particulier-header">
  <div class="particulier-header__toolbar">
    <div class="particulier-header__toolbar__header">
      <a (click)="closeModal()" class="particulier-header__back-link"></a>
      <h2 class="particulier-header__toolbar__title">
        {{ 'CONGIGURATION_PAGE.LEGALS' | translate }}
      </h2>
    </div>
  </div>
</ion-header>
<ion-content class="legals-modal-content">
  <div class="legals-modal-logo">
    <app-logo [src]="'../../../assets/icon/logo.png'" [alt]="'App Logo'" [width]="'80px'"
      [height]="'auto'" [showVersion]="false" [enableScale]="true">
    </app-logo>
  </div>
  <div class="legals-modal-body">
    <h2 class="legals-modal-title">{{ 'LEGALS.TITLE' | translate }}</h2>

    <!-- <h3 class="legals-modal-app-name">{{ 'LEGALS.APP_NAME' | translate }}</h3> -->
    <p><strong>{{ 'LEGALS.LAST_UPDATE' | translate }}</strong> 12-12-2025</p>

    <h3>{{ 'LEGALS.SECTION_1_TITLE' | translate }}</h3>
    <p>{{ 'LEGALS.SECTION_1_P1' | translate }}</p>
    <p class="legals-modal-section-1-company">
      <span class="legals-modal-section-1-company-company">{{ 'LEGALS.SECTION_1_COMPANY' | translate }}</span>
      <br />
      <span class="legals-modal-section-1-company-info-title">{{ 'LEGALS.SECTION_1_SIREN_TITLE' | translate }}</span>
      <span class="legals-modal-section-1-company-info-value">{{ 'LEGALS.SECTION_1_SIREN_VALUE' | translate }}</span>
      <br />
      <span class="legals-modal-section-1-company-info-title">{{ 'LEGALS.SECTION_1_ADDRESS_TITLE' | translate }}</span>
      <span class="legals-modal-section-1-company-info-value">{{ 'LEGALS.SECTION_1_ADDRESS_VALUE' | translate }}</span>
      <br />
      <span class="legals-modal-section-1-company-info-title">{{ 'LEGALS.SECTION_1_WEBSITE' | translate }}</span>
      <span class="legals-modal-section-1-company-info-value">
        <a href="https://bobexpresse.com" target="_blank" rel="noopener">bobexpresse.com</a>
      </span>
    </p>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_1_P2' | translate }}</p>
    <ul class="legals-modal-section-1-p2-list">
      <li>{{ 'LEGALS.SECTION_1_LI1' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_1_LI2' | translate }}</li>
    </ul>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_1_P3' | translate }}</p>

    <h3>{{ 'LEGALS.SECTION_2_TITLE' | translate }}</h3>
    <ul class="legals-modal-section-1-p2-list">
      <li>
        <span class="legals-modal-section-2-title">{{ 'LEGALS.SECTION_2_CLIENT' | translate }}</span>
        <span class="legals-modal-section-2-value">{{ 'LEGALS.SECTION_2_CLIENT_VALUE' | translate }}</span>
      </li>
      <li>
        <span class="legals-modal-section-2-title">{{ 'LEGALS.SECTION_2_PRO' | translate }}</span>
        <span class="legals-modal-section-2-value">{{ 'LEGALS.SECTION_2_PRO_VALUE' | translate }}</span>
      </li>
      <li>
        <span class="legals-modal-section-2-title">{{ 'LEGALS.SECTION_2_PRESTATION' | translate }}</span>
        <span class="legals-modal-section-2-value">{{ 'LEGALS.SECTION_2_PRESTATION_VALUE' | translate }}</span>
      </li>
      <li>
        <span class="legals-modal-section-2-title">{{ 'LEGALS.SECTION_2_PSP' | translate }}</span>
        <span class="legals-modal-section-2-value">{{ 'LEGALS.SECTION_2_PSP_VALUE' | translate }}</span>
      </li>
      <li>
        <span class="legals-modal-section-2-title">{{ 'LEGALS.SECTION_2_COMMISSION' | translate }}</span>
        <span class="legals-modal-section-2-value">{{ 'LEGALS.SECTION_2_COMMISSION_VALUE' | translate }}</span>
      </li>
      <li>
        <span class="legals-modal-section-2-title">{{ 'LEGALS.SECTION_2_APP' | translate }}</span>
        <span class="legals-modal-section-2-value">{{ 'LEGALS.SECTION_2_APP_VALUE' | translate }}</span>
      </li>
    </ul>

    <h3>{{ 'LEGALS.SECTION_3_TITLE' | translate }}</h3>
    <h4 class="legals-modal-section-3-subtitle">{{ 'LEGALS.SECTION_3_SUBTITLE' | translate }}</h4>
    <ol class="legals-modal-section-3-list">
      <li>{{ 'LEGALS.SECTION_3_STEP1' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_3_STEP2' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_3_STEP3' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_3_STEP4' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_3_STEP5' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_3_STEP6' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_3_STEP7' | translate }}</li>
    </ol>

    <h3>{{ 'LEGALS.SECTION_4_TITLE' | translate }}</h3>
    <p class="legals-modal-section-1-p2">
      {{ 'LEGALS.SECTION_4_P1' | translate }}
    </p>
    <p class="legals-modal-section-1-p2" >
      {{ 'LEGALS.SECTION_4_P2' | translate }}
    </p>
    <ul class="legals-modal-section-1-p2-list">
      <li>{{ 'LEGALS.SECTION_4_LI1' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_4_LI2' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_4_LI3' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_4_LI4' | translate }}</li>
    </ul>

    <h3>{{ 'LEGALS.SECTION_5_TITLE' | translate }}</h3>
    <h4 class="legals-modal-section-3-subtitle">{{ 'LEGALS.SECTION_5_SUBTITLE' | translate }}</h4>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_5_P1' | translate }}</p>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_5_P2' | translate }}</p>
    <h4 class="legals-modal-section-3-subtitle">{{ 'LEGALS.SECTION_5_SUBTITLE2' | translate }}</h4>
    <p class="legals-modal-section-1-p2">
      {{ 'LEGALS.SECTION_5_P3' | translate }}
      <strong>{{ 'LEGALS.SECTION_5_COMMISSION' | translate }}</strong>
    </p>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_5_P4' | translate }}</p>
    <h4 class="legals-modal-section-3-subtitle">{{ 'LEGALS.SECTION_5_SUBTITLE3' | translate }}</h4>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_5_P5' | translate }}</p>
    <ul class="legals-modal-section-1-p2-list">
      <li>{{ 'LEGALS.SECTION_5_LI1' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_5_LI2' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_5_LI3' | translate }}</li>
    </ul>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_5_P6' | translate }}</p>

    <h3>{{ 'LEGALS.SECTION_6_TITLE' | translate }}</h3>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_6_P1' | translate }}</p>
    <ul class="legals-modal-section-1-p2-list">
      <li>{{ 'LEGALS.SECTION_6_LI1' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_6_LI2' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_6_LI3' | translate }}</li>
    </ul>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_6_P2' | translate }}</p>
    <ul class="legals-modal-section-1-p2-list">
      <li>{{ 'LEGALS.SECTION_6_LI4' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_6_LI5' | translate }}</li>
    </ul>

    <h3>{{ 'LEGALS.SECTION_7_TITLE' | translate }}</h3>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_7_P1' | translate }}</p>
    <ul class="legals-modal-section-1-p2-list">
      <li>{{ 'LEGALS.SECTION_7_LI1' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_7_LI2' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_7_LI3' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_7_LI4' | translate }}</li>
    </ul>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_7_P2' | translate }}</p>
    <p class="legals-modal-section-1-p2"><strong>{{ 'LEGALS.SECTION_7_PENALTY' | translate }}</strong></p>

    <h3>{{ 'LEGALS.SECTION_8_TITLE' | translate }}</h3>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_8_P1' | translate }}</p>
    <ul class="legals-modal-section-1-p2-list">
      <li>{{ 'LEGALS.SECTION_8_LI1' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_8_LI2' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_8_LI3' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_8_LI4' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_8_LI5' | translate }}</li>
    </ul>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_8_P2' | translate }}</p>
    <ul class="legals-modal-section-1-p2-list">
      <li>{{ 'LEGALS.SECTION_8_LI6' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_8_LI7' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_8_LI8' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_8_LI9' | translate }}</li>
    </ul>

    <h3>{{ 'LEGALS.SECTION_9_TITLE' | translate }}</h3>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_9_P1' | translate }}</p>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_9_P2' | translate }}</p>
    <ul class="legals-modal-section-1-p2-list">
      <li>{{ 'LEGALS.SECTION_9_LI1' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_9_LI2' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_9_LI3' | translate }}</li>
    </ul>

    <h3>{{ 'LEGALS.SECTION_10_TITLE' | translate }}</h3>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_10_P1' | translate }}</p>

    <h3>{{ 'LEGALS.SECTION_11_TITLE' | translate }}</h3>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_11_P1' | translate }}</p>
    <ul class="legals-modal-section-1-p2-list">
      <li>{{ 'LEGALS.SECTION_11_LI1' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_11_LI2' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_11_LI3' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_11_LI4' | translate }}</li>
    </ul>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_11_P2' | translate }}</p>

    <h3>{{ 'LEGALS.SECTION_12_TITLE' | translate }}</h3>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_12_P1' | translate }}</p>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_12_P2' | translate }}</p>

    <h3>{{ 'LEGALS.SECTION_13_TITLE' | translate }}</h3>
    <p class="legals-modal-section-1-p2">{{ 'LEGALS.SECTION_13_P1' | translate }}</p>
    <ul class="legals-modal-section-1-p2-list">
      <li>{{ 'LEGALS.SECTION_13_LI1' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_13_LI2' | translate }}</li>
      <li>{{ 'LEGALS.SECTION_13_LI3' | translate }}</li>
    </ul>
  </div>
</ion-content>